"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockQuoteResults = void 0;
var _MockOwner = require("./MockOwner");
var _MockDog = require("./MockDog");
var _MockCat = require("./MockCat");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MockQuoteResults = exports.MockQuoteResults = {
  'exception': '',
  'statusCode': 200,
  'payLoad': {
    'onlineQuoteNumber': 2005191351,
    'onlineNumber': 0,
    'quoteReferenceNumber': 'PC20051913516',
    'appId': '48ffc8b7-1dd3-42ac-96ce-ac8c4b79fa0d',
    'owner': _MockOwner.MockOwner,
    'pets': [_objectSpread(_objectSpread({}, _MockDog.MockDog), {}, {
      'petQuotes': [{
        'productCode': 'PR04',
        'productName': null,
        'excess': 0,
        'excessCode': '3917',
        'levelOfCover': 80,
        'levelOfCoverCode': '3917',
        'annualBenefitLimitCode': '18640',
        'annualBenefitLimit': 20000,
        'planNumber': 964,
        'combinationGroupID': 4000001,
        'basePremium': 451.89,
        'stampDuty': 44.74,
        'gst': 45.19,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 47.15,
        'totalBasePremium': 45.15,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR04',
        'productName': null,
        'excess': 500,
        'excessCode': '3919',
        'levelOfCover': 80,
        'levelOfCoverCode': '3919',
        'annualBenefitLimitCode': '18640',
        'annualBenefitLimit': 20000,
        'planNumber': 964,
        'combinationGroupID': 4000002,
        'basePremium': 232.23,
        'stampDuty': 22.99,
        'gst': 23.22,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 25.2,
        'totalBasePremium': 23.2,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR04',
        'productName': null,
        'excess': 250,
        'excessCode': '3918',
        'levelOfCover': 80,
        'levelOfCoverCode': '3918',
        'annualBenefitLimitCode': '18640',
        'annualBenefitLimit': 20000,
        'planNumber': 964,
        'combinationGroupID': 4000003,
        'basePremium': 296.39,
        'stampDuty': 29.34,
        'gst': 29.64,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 31.61,
        'totalBasePremium': 29.61,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR15',
        'productName': null,
        'excess': 0,
        'excessCode': '3923',
        'levelOfCover': 80,
        'levelOfCoverCode': '3923',
        'annualBenefitLimitCode': '18664',
        'annualBenefitLimit': 20000,
        'planNumber': 966,
        'combinationGroupID': 7000001,
        'basePremium': 518.01,
        'stampDuty': 51.28,
        'gst': 51.8,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 53.76,
        'totalBasePremium': 51.76,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR15',
        'productName': null,
        'excess': 500,
        'excessCode': '3925',
        'levelOfCover': 80,
        'levelOfCoverCode': '3925',
        'annualBenefitLimitCode': '18664',
        'annualBenefitLimit': 20000,
        'planNumber': 966,
        'combinationGroupID': 7000002,
        'basePremium': 298.35,
        'stampDuty': 29.54,
        'gst': 29.84,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 31.81,
        'totalBasePremium': 29.81,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR15',
        'productName': null,
        'excess': 250,
        'excessCode': '3924',
        'levelOfCover': 80,
        'levelOfCoverCode': '3924',
        'annualBenefitLimitCode': '18664',
        'annualBenefitLimit': 20000,
        'planNumber': 966,
        'combinationGroupID': 7000003,
        'basePremium': 362.51,
        'stampDuty': 35.89,
        'gst': 36.25,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 38.22,
        'totalBasePremium': 36.22,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR20',
        'productName': null,
        'excess': 0,
        'excessCode': '3920',
        'levelOfCover': 80,
        'levelOfCoverCode': '3920',
        'annualBenefitLimitCode': '18651',
        'annualBenefitLimit': 20000,
        'planNumber': 965,
        'combinationGroupID': 8000001,
        'basePremium': 530.5,
        'stampDuty': 52.52,
        'gst': 53.05,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 55.01,
        'totalBasePremium': 53.01,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR20',
        'productName': null,
        'excess': 500,
        'excessCode': '3922',
        'levelOfCover': 80,
        'levelOfCoverCode': '3922',
        'annualBenefitLimitCode': '18651',
        'annualBenefitLimit': 20000,
        'planNumber': 965,
        'combinationGroupID': 8000002,
        'basePremium': 251.88,
        'stampDuty': 24.94,
        'gst': 25.19,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 27.17,
        'totalBasePremium': 25.17,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR20',
        'productName': null,
        'excess': 250,
        'excessCode': '3921',
        'levelOfCover': 80,
        'levelOfCoverCode': '3921',
        'annualBenefitLimitCode': '18651',
        'annualBenefitLimit': 20000,
        'planNumber': 965,
        'combinationGroupID': 8000003,
        'basePremium': 319.97,
        'stampDuty': 31.68,
        'gst': 32,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 33.97,
        'totalBasePremium': 31.97,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR21',
        'productName': null,
        'excess': 0,
        'excessCode': '3926',
        'levelOfCover': 80,
        'levelOfCoverCode': '3926',
        'annualBenefitLimitCode': '18678',
        'annualBenefitLimit': 20000,
        'planNumber': 967,
        'combinationGroupID': 9000001,
        'basePremium': 596.62,
        'stampDuty': 59.07,
        'gst': 59.66,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 61.61,
        'totalBasePremium': 59.61,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR21',
        'productName': null,
        'excess': 500,
        'excessCode': '3928',
        'levelOfCover': 80,
        'levelOfCoverCode': '3928',
        'annualBenefitLimitCode': '18678',
        'annualBenefitLimit': 20000,
        'planNumber': 967,
        'combinationGroupID': 9000002,
        'basePremium': 318,
        'stampDuty': 31.48,
        'gst': 31.8,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 33.77,
        'totalBasePremium': 31.77,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR21',
        'productName': null,
        'excess': 250,
        'excessCode': '3927',
        'levelOfCover': 80,
        'levelOfCoverCode': '3927',
        'annualBenefitLimitCode': '18678',
        'annualBenefitLimit': 20000,
        'planNumber': 967,
        'combinationGroupID': 9000003,
        'basePremium': 386.1,
        'stampDuty': 38.22,
        'gst': 38.61,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 40.58,
        'totalBasePremium': 38.58,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR23',
        'productName': null,
        'excess': 0,
        'excessCode': '3947',
        'levelOfCover': 80,
        'levelOfCoverCode': '3947',
        'annualBenefitLimitCode': '18730',
        'annualBenefitLimit': 20000,
        'planNumber': 975,
        'combinationGroupID': 11000001,
        'basePremium': 814.56,
        'stampDuty': 80.64,
        'gst': 81.46,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 83.39,
        'totalBasePremium': 81.39,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR23',
        'productName': null,
        'excess': 500,
        'excessCode': '3949',
        'levelOfCover': 80,
        'levelOfCoverCode': '3949',
        'annualBenefitLimitCode': '18730',
        'annualBenefitLimit': 20000,
        'planNumber': 975,
        'combinationGroupID': 11000002,
        'basePremium': 374.51,
        'stampDuty': 37.08,
        'gst': 37.45,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 39.42,
        'totalBasePremium': 37.42,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR23',
        'productName': null,
        'excess': 250,
        'excessCode': '3948',
        'levelOfCover': 80,
        'levelOfCoverCode': '3948',
        'annualBenefitLimitCode': '18730',
        'annualBenefitLimit': 20000,
        'planNumber': 975,
        'combinationGroupID': 11000003,
        'basePremium': 484.08,
        'stampDuty': 47.92,
        'gst': 48.41,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 50.37,
        'totalBasePremium': 48.37,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR24',
        'productName': null,
        'excess': 0,
        'excessCode': '3953',
        'levelOfCover': 80,
        'levelOfCoverCode': '3953',
        'annualBenefitLimitCode': '18754',
        'annualBenefitLimit': 20000,
        'planNumber': 977,
        'combinationGroupID': 12000001,
        'basePremium': 880.69,
        'stampDuty': 87.19,
        'gst': 88.07,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 90,
        'totalBasePremium': 88,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR24',
        'productName': null,
        'excess': 500,
        'excessCode': '3955',
        'levelOfCover': 80,
        'levelOfCoverCode': '3955',
        'annualBenefitLimitCode': '18754',
        'annualBenefitLimit': 20000,
        'planNumber': 977,
        'combinationGroupID': 12000002,
        'basePremium': 440.63,
        'stampDuty': 43.62,
        'gst': 44.06,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 46.03,
        'totalBasePremium': 44.03,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR24',
        'productName': null,
        'excess': 250,
        'excessCode': '3954',
        'levelOfCover': 80,
        'levelOfCoverCode': '3954',
        'annualBenefitLimitCode': '18754',
        'annualBenefitLimit': 20000,
        'planNumber': 977,
        'combinationGroupID': 12000003,
        'basePremium': 550.2,
        'stampDuty': 54.47,
        'gst': 55.02,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 56.97,
        'totalBasePremium': 54.97,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 0,
        'excessCode': '3929',
        'levelOfCover': 80,
        'levelOfCoverCode': '3929',
        'annualBenefitLimitCode': '18689',
        'annualBenefitLimit': 30000,
        'planNumber': 969,
        'combinationGroupID': 13000001,
        'basePremium': 975.83,
        'stampDuty': 96.61,
        'gst': 97.58,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 99.5,
        'totalBasePremium': 97.5,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 500,
        'excessCode': '3931',
        'levelOfCover': 80,
        'levelOfCoverCode': '3931',
        'annualBenefitLimitCode': '18689',
        'annualBenefitLimit': 30000,
        'planNumber': 969,
        'combinationGroupID': 13000002,
        'basePremium': 432.73,
        'stampDuty': 42.84,
        'gst': 43.27,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 45.24,
        'totalBasePremium': 43.24,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 250,
        'excessCode': '3930',
        'levelOfCover': 80,
        'levelOfCoverCode': '3930',
        'annualBenefitLimitCode': '18689',
        'annualBenefitLimit': 30000,
        'planNumber': 969,
        'combinationGroupID': 13000003,
        'basePremium': 558.64,
        'stampDuty': 55.3,
        'gst': 55.86,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 57.82,
        'totalBasePremium': 55.82,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 500,
        'excessCode': '3952',
        'levelOfCover': 80,
        'levelOfCoverCode': '3952',
        'annualBenefitLimitCode': '18741',
        'annualBenefitLimit': 20000,
        'planNumber': 976,
        'combinationGroupID': 13000004,
        'basePremium': 393.88,
        'stampDuty': 38.99,
        'gst': 39.39,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 41.36,
        'totalBasePremium': 39.36,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 250,
        'excessCode': '3951',
        'levelOfCover': 80,
        'levelOfCoverCode': '3951',
        'annualBenefitLimitCode': '18741',
        'annualBenefitLimit': 20000,
        'planNumber': 976,
        'combinationGroupID': 13000005,
        'basePremium': 507.33,
        'stampDuty': 50.23,
        'gst': 50.73,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 52.69,
        'totalBasePremium': 50.69,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 0,
        'excessCode': '3950',
        'levelOfCover': 80,
        'levelOfCoverCode': '3950',
        'annualBenefitLimitCode': '18741',
        'annualBenefitLimit': 20000,
        'planNumber': 976,
        'combinationGroupID': 13000006,
        'basePremium': 892.06,
        'stampDuty': 88.31,
        'gst': 89.21,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 91.13,
        'totalBasePremium': 89.13,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 0,
        'excessCode': '3932',
        'levelOfCover': 80,
        'levelOfCoverCode': '3932',
        'annualBenefitLimitCode': '18697',
        'annualBenefitLimit': 30000,
        'planNumber': 970,
        'combinationGroupID': 14000001,
        'basePremium': 1041.95,
        'stampDuty': 103.15,
        'gst': 104.2,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 106.11,
        'totalBasePremium': 104.11,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 500,
        'excessCode': '3934',
        'levelOfCover': 80,
        'levelOfCoverCode': '3934',
        'annualBenefitLimitCode': '18697',
        'annualBenefitLimit': 30000,
        'planNumber': 970,
        'combinationGroupID': 14000002,
        'basePremium': 498.86,
        'stampDuty': 49.39,
        'gst': 49.89,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 51.84,
        'totalBasePremium': 49.84,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 250,
        'excessCode': '3933',
        'levelOfCover': 80,
        'levelOfCoverCode': '3933',
        'annualBenefitLimitCode': '18697',
        'annualBenefitLimit': 30000,
        'planNumber': 970,
        'combinationGroupID': 14000003,
        'basePremium': 624.76,
        'stampDuty': 61.85,
        'gst': 62.48,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 64.42,
        'totalBasePremium': 62.42,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 500,
        'excessCode': '3958',
        'levelOfCover': 80,
        'levelOfCoverCode': '3958',
        'annualBenefitLimitCode': '18768',
        'annualBenefitLimit': 20000,
        'planNumber': 978,
        'combinationGroupID': 14000004,
        'basePremium': 460,
        'stampDuty': 45.54,
        'gst': 46,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 47.96,
        'totalBasePremium': 45.96,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 250,
        'excessCode': '3957',
        'levelOfCover': 80,
        'levelOfCoverCode': '3957',
        'annualBenefitLimitCode': '18768',
        'annualBenefitLimit': 20000,
        'planNumber': 978,
        'combinationGroupID': 14000005,
        'basePremium': 573.45,
        'stampDuty': 56.77,
        'gst': 57.34,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 59.3,
        'totalBasePremium': 57.3,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 0,
        'excessCode': '3956',
        'levelOfCover': 80,
        'levelOfCoverCode': '3956',
        'annualBenefitLimitCode': '18768',
        'annualBenefitLimit': 20000,
        'planNumber': 978,
        'combinationGroupID': 14000006,
        'basePremium': 958.18,
        'stampDuty': 94.86,
        'gst': 95.82,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': 0,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 97.74,
        'totalBasePremium': 95.74,
        'totalLoading': 2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }],
      'selectedQuote': null,
      'petProducts': [{
        'productCode': 'PR04',
        'productName': 'Extended Accident',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR15',
        'productName': 'Extended Accident & Routine',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR20',
        'productName': 'Extended Accident & Dental',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR21',
        'productName': 'Extended Accident & Routine & Dental',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR23',
        'productName': 'Accident and Illness and Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR24',
        'productName': 'Accident and Illness and Routine and Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR25',
        'productName': 'Accident & Illness & Dental & Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR26',
        'productName': 'Accident & Illness & Routine & Dental & Hip',
        'partnerNumber': 'PINSCOM'
      }],
      'targetMargetKnockoutSelection': null,
      'productDisclosureCoverage': null,
      'productDisclosureNonCoverage': null
    }), _objectSpread(_objectSpread({}, _MockCat.MockCat), {}, {
      'petQuotes': [{
        'productCode': 'PR07',
        'productName': null,
        'excess': 0,
        'excessCode': '3941',
        'levelOfCover': 80,
        'levelOfCoverCode': '3941',
        'annualBenefitLimitCode': '18716',
        'annualBenefitLimit': 20000,
        'planNumber': 973,
        'combinationGroupID': 22000001,
        'basePremium': 341.82,
        'stampDuty': 33.84,
        'gst': 34.18,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -34.18,
          'loadingStampDuty': -3.38,
          'loadingGst': -3.42,
          'loadingNo': 20077,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -3.42,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 32.74,
        'totalBasePremium': 34.15,
        'totalLoading': -1.42,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR07',
        'productName': null,
        'excess': 500,
        'excessCode': '3943',
        'levelOfCover': 80,
        'levelOfCoverCode': '3943',
        'annualBenefitLimitCode': '18716',
        'annualBenefitLimit': 20000,
        'planNumber': 973,
        'combinationGroupID': 22000002,
        'basePremium': 221.7,
        'stampDuty': 21.95,
        'gst': 22.17,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -22.17,
          'loadingStampDuty': -2.2,
          'loadingGst': -2.22,
          'loadingNo': 20077,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.22,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 21.94,
        'totalBasePremium': 22.15,
        'totalLoading': -0.22,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR07',
        'productName': null,
        'excess': 250,
        'excessCode': '3942',
        'levelOfCover': 80,
        'levelOfCoverCode': '3942',
        'annualBenefitLimitCode': '18716',
        'annualBenefitLimit': 20000,
        'planNumber': 973,
        'combinationGroupID': 22000003,
        'basePremium': 246.36,
        'stampDuty': 24.39,
        'gst': 24.64,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -24.64,
          'loadingStampDuty': -2.44,
          'loadingGst': -2.46,
          'loadingNo': 20077,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.46,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 24.15,
        'totalBasePremium': 24.62,
        'totalLoading': -0.46,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR08',
        'productName': null,
        'excess': 0,
        'excessCode': '3935',
        'levelOfCover': 80,
        'levelOfCoverCode': '3935',
        'annualBenefitLimitCode': '18701',
        'annualBenefitLimit': 20000,
        'planNumber': 971,
        'combinationGroupID': 23000001,
        'basePremium': 275.7,
        'stampDuty': 27.29,
        'gst': 27.57,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -27.57,
          'loadingStampDuty': -2.73,
          'loadingGst': -2.76,
          'loadingNo': 20039,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.76,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 26.79,
        'totalBasePremium': 27.55,
        'totalLoading': -0.76,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR08',
        'productName': null,
        'excess': 500,
        'excessCode': '3937',
        'levelOfCover': 80,
        'levelOfCoverCode': '3937',
        'annualBenefitLimitCode': '18701',
        'annualBenefitLimit': 20000,
        'planNumber': 971,
        'combinationGroupID': 23000002,
        'basePremium': 155.58,
        'stampDuty': 15.4,
        'gst': 15.56,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -15.56,
          'loadingStampDuty': -1.54,
          'loadingGst': -1.56,
          'loadingNo': 20039,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -1.56,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 15.99,
        'totalBasePremium': 15.54,
        'totalLoading': 0.44,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR08',
        'productName': null,
        'excess': 250,
        'excessCode': '3936',
        'levelOfCover': 80,
        'levelOfCoverCode': '3936',
        'annualBenefitLimitCode': '18701',
        'annualBenefitLimit': 20000,
        'planNumber': 971,
        'combinationGroupID': 23000003,
        'basePremium': 180.24,
        'stampDuty': 17.84,
        'gst': 18.02,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -18.02,
          'loadingStampDuty': -1.78,
          'loadingGst': -1.8,
          'loadingNo': 20039,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -1.8,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 18.21,
        'totalBasePremium': 18.01,
        'totalLoading': 0.2,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR23',
        'productName': null,
        'excess': 0,
        'excessCode': '3947',
        'levelOfCover': 80,
        'levelOfCoverCode': '3947',
        'annualBenefitLimitCode': '18730',
        'annualBenefitLimit': 20000,
        'planNumber': 975,
        'combinationGroupID': 28000001,
        'basePremium': 378.82,
        'stampDuty': 37.5,
        'gst': 37.88,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -37.88,
          'loadingStampDuty': -3.75,
          'loadingGst': -3.79,
          'loadingNo': 20113,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -3.78,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 36.06,
        'totalBasePremium': 37.85,
        'totalLoading': -1.78,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR23',
        'productName': null,
        'excess': 500,
        'excessCode': '3949',
        'levelOfCover': 80,
        'levelOfCoverCode': '3949',
        'annualBenefitLimitCode': '18730',
        'annualBenefitLimit': 20000,
        'planNumber': 975,
        'combinationGroupID': 28000002,
        'basePremium': 183.18,
        'stampDuty': 18.14,
        'gst': 18.32,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -18.32,
          'loadingStampDuty': -1.81,
          'loadingGst': -1.83,
          'loadingNo': 20113,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -1.83,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 18.47,
        'totalBasePremium': 18.3,
        'totalLoading': 0.17,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR23',
        'productName': null,
        'excess': 250,
        'excessCode': '3948',
        'levelOfCover': 80,
        'levelOfCoverCode': '3948',
        'annualBenefitLimitCode': '18730',
        'annualBenefitLimit': 20000,
        'planNumber': 975,
        'combinationGroupID': 28000003,
        'basePremium': 229.47,
        'stampDuty': 22.72,
        'gst': 22.95,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -22.95,
          'loadingStampDuty': -2.27,
          'loadingGst': -2.3,
          'loadingNo': 20113,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.29,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 22.64,
        'totalBasePremium': 22.93,
        'totalLoading': -0.29,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR24',
        'productName': null,
        'excess': 0,
        'excessCode': '3953',
        'levelOfCover': 80,
        'levelOfCoverCode': '3953',
        'annualBenefitLimitCode': '18754',
        'annualBenefitLimit': 20000,
        'planNumber': 977,
        'combinationGroupID': 29000001,
        'basePremium': 444.94,
        'stampDuty': 44.05,
        'gst': 44.49,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -44.49,
          'loadingStampDuty': -4.4,
          'loadingGst': -4.45,
          'loadingNo': 20151,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -4.44,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 42.01,
        'totalBasePremium': 44.46,
        'totalLoading': -2.44,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR24',
        'productName': null,
        'excess': 500,
        'excessCode': '3955',
        'levelOfCover': 80,
        'levelOfCoverCode': '3955',
        'annualBenefitLimitCode': '18754',
        'annualBenefitLimit': 20000,
        'planNumber': 977,
        'combinationGroupID': 29000002,
        'basePremium': 249.31,
        'stampDuty': 24.68,
        'gst': 24.93,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -24.93,
          'loadingStampDuty': -2.47,
          'loadingGst': -2.49,
          'loadingNo': 20151,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.49,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 24.42,
        'totalBasePremium': 24.91,
        'totalLoading': -0.49,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR24',
        'productName': null,
        'excess': 250,
        'excessCode': '3954',
        'levelOfCover': 80,
        'levelOfCoverCode': '3954',
        'annualBenefitLimitCode': '18754',
        'annualBenefitLimit': 20000,
        'planNumber': 977,
        'combinationGroupID': 29000003,
        'basePremium': 295.59,
        'stampDuty': 29.26,
        'gst': 29.56,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -29.56,
          'loadingStampDuty': -2.93,
          'loadingGst': -2.96,
          'loadingNo': 20151,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.95,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 28.58,
        'totalBasePremium': 29.53,
        'totalLoading': -0.95,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 0,
        'excessCode': '3929',
        'levelOfCover': 80,
        'levelOfCoverCode': '3929',
        'annualBenefitLimitCode': '18689',
        'annualBenefitLimit': 30000,
        'planNumber': 969,
        'combinationGroupID': 30000001,
        'basePremium': 490.11,
        'stampDuty': 48.52,
        'gst': 49.01,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -49.01,
          'loadingStampDuty': -4.85,
          'loadingGst': -4.9,
          'loadingNo': 20003,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -4.9,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 46.07,
        'totalBasePremium': 48.97,
        'totalLoading': -2.9,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 500,
        'excessCode': '3931',
        'levelOfCover': 80,
        'levelOfCoverCode': '3931',
        'annualBenefitLimitCode': '18689',
        'annualBenefitLimit': 30000,
        'planNumber': 969,
        'combinationGroupID': 30000002,
        'basePremium': 215.48,
        'stampDuty': 21.33,
        'gst': 21.55,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -21.55,
          'loadingStampDuty': -2.13,
          'loadingGst': -2.16,
          'loadingNo': 20003,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.15,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 21.38,
        'totalBasePremium': 21.53,
        'totalLoading': -0.15,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 250,
        'excessCode': '3930',
        'levelOfCover': 80,
        'levelOfCoverCode': '3930',
        'annualBenefitLimitCode': '18689',
        'annualBenefitLimit': 30000,
        'planNumber': 969,
        'combinationGroupID': 30000003,
        'basePremium': 270.83,
        'stampDuty': 26.81,
        'gst': 27.08,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -27.08,
          'loadingStampDuty': -2.68,
          'loadingGst': -2.71,
          'loadingNo': 20003,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.71,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 26.35,
        'totalBasePremium': 27.06,
        'totalLoading': -0.71,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 500,
        'excessCode': '3952',
        'levelOfCover': 80,
        'levelOfCoverCode': '3952',
        'annualBenefitLimitCode': '18741',
        'annualBenefitLimit': 20000,
        'planNumber': 976,
        'combinationGroupID': 30000004,
        'basePremium': 203.2,
        'stampDuty': 20.12,
        'gst': 20.32,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -20.32,
          'loadingStampDuty': -2.01,
          'loadingGst': -2.03,
          'loadingNo': 20132,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.03,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 20.27,
        'totalBasePremium': 20.3,
        'totalLoading': -0.03,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 250,
        'excessCode': '3951',
        'levelOfCover': 80,
        'levelOfCoverCode': '3951',
        'annualBenefitLimitCode': '18741',
        'annualBenefitLimit': 20000,
        'planNumber': 976,
        'combinationGroupID': 30000005,
        'basePremium': 253.49,
        'stampDuty': 25.1,
        'gst': 25.35,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -25.35,
          'loadingStampDuty': -2.51,
          'loadingGst': -2.54,
          'loadingNo': 20132,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.53,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 24.8,
        'totalBasePremium': 25.33,
        'totalLoading': -0.53,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR25',
        'productName': null,
        'excess': 0,
        'excessCode': '3950',
        'levelOfCover': 80,
        'levelOfCoverCode': '3950',
        'annualBenefitLimitCode': '18741',
        'annualBenefitLimit': 20000,
        'planNumber': 976,
        'combinationGroupID': 30000006,
        'basePremium': 458.89,
        'stampDuty': 45.43,
        'gst': 45.89,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -45.89,
          'loadingStampDuty': -4.54,
          'loadingGst': -4.59,
          'loadingNo': 20132,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -4.58,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 43.27,
        'totalBasePremium': 45.85,
        'totalLoading': -2.58,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 0,
        'excessCode': '3932',
        'levelOfCover': 80,
        'levelOfCoverCode': '3932',
        'annualBenefitLimitCode': '18697',
        'annualBenefitLimit': 30000,
        'planNumber': 970,
        'combinationGroupID': 31000001,
        'basePremium': 556.23,
        'stampDuty': 55.07,
        'gst': 55.62,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -55.62,
          'loadingStampDuty': -5.51,
          'loadingGst': -5.56,
          'loadingNo': 20022,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -5.56,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 52.02,
        'totalBasePremium': 55.58,
        'totalLoading': -3.56,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 500,
        'excessCode': '3934',
        'levelOfCover': 80,
        'levelOfCoverCode': '3934',
        'annualBenefitLimitCode': '18697',
        'annualBenefitLimit': 30000,
        'planNumber': 970,
        'combinationGroupID': 31000002,
        'basePremium': 281.6,
        'stampDuty': 27.88,
        'gst': 28.16,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -28.16,
          'loadingStampDuty': -2.79,
          'loadingGst': -2.82,
          'loadingNo': 20022,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.81,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 27.32,
        'totalBasePremium': 28.14,
        'totalLoading': -0.81,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 250,
        'excessCode': '3933',
        'levelOfCover': 80,
        'levelOfCoverCode': '3933',
        'annualBenefitLimitCode': '18697',
        'annualBenefitLimit': 30000,
        'planNumber': 970,
        'combinationGroupID': 31000003,
        'basePremium': 336.95,
        'stampDuty': 33.36,
        'gst': 33.7,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -33.7,
          'loadingStampDuty': -3.34,
          'loadingGst': -3.37,
          'loadingNo': 20022,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -3.37,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 32.3,
        'totalBasePremium': 33.67,
        'totalLoading': -1.37,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 500,
        'excessCode': '3958',
        'levelOfCover': 80,
        'levelOfCoverCode': '3958',
        'annualBenefitLimitCode': '18768',
        'annualBenefitLimit': 20000,
        'planNumber': 978,
        'combinationGroupID': 31000004,
        'basePremium': 269.32,
        'stampDuty': 26.66,
        'gst': 26.93,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -26.93,
          'loadingStampDuty': -2.67,
          'loadingGst': -2.69,
          'loadingNo': 20168,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.69,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 26.22,
        'totalBasePremium': 26.91,
        'totalLoading': -0.69,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 250,
        'excessCode': '3957',
        'levelOfCover': 80,
        'levelOfCoverCode': '3957',
        'annualBenefitLimitCode': '18768',
        'annualBenefitLimit': 20000,
        'planNumber': 978,
        'combinationGroupID': 31000005,
        'basePremium': 319.61,
        'stampDuty': 31.64,
        'gst': 31.96,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -31.96,
          'loadingStampDuty': -3.16,
          'loadingGst': -3.2,
          'loadingNo': 20168,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -3.19,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 30.74,
        'totalBasePremium': 31.93,
        'totalLoading': -1.19,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR26',
        'productName': null,
        'excess': 0,
        'excessCode': '3956',
        'levelOfCover': 80,
        'levelOfCoverCode': '3956',
        'annualBenefitLimitCode': '18768',
        'annualBenefitLimit': 20000,
        'planNumber': 978,
        'combinationGroupID': 31000006,
        'basePremium': 525.01,
        'stampDuty': 51.98,
        'gst': 52.5,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -52.5,
          'loadingStampDuty': -5.2,
          'loadingGst': -5.25,
          'loadingNo': 20168,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -5.25,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 49.21,
        'totalBasePremium': 52.46,
        'totalLoading': -3.25,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR31',
        'productName': null,
        'excess': 0,
        'excessCode': '3938',
        'levelOfCover': 80,
        'levelOfCoverCode': '3938',
        'annualBenefitLimitCode': '18708',
        'annualBenefitLimit': 20000,
        'planNumber': 972,
        'combinationGroupID': 33000001,
        'basePremium': 356.86,
        'stampDuty': 35.33,
        'gst': 35.69,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -35.69,
          'loadingStampDuty': -3.53,
          'loadingGst': -3.57,
          'loadingNo': 20058,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -3.57,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 34.09,
        'totalBasePremium': 35.66,
        'totalLoading': -1.57,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR31',
        'productName': null,
        'excess': 500,
        'excessCode': '3940',
        'levelOfCover': 80,
        'levelOfCoverCode': '3940',
        'annualBenefitLimitCode': '18708',
        'annualBenefitLimit': 20000,
        'planNumber': 972,
        'combinationGroupID': 33000002,
        'basePremium': 175.87,
        'stampDuty': 17.41,
        'gst': 17.59,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -17.59,
          'loadingStampDuty': -1.74,
          'loadingGst': -1.76,
          'loadingNo': 20058,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -1.76,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 17.82,
        'totalBasePremium': 17.57,
        'totalLoading': 0.24,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR31',
        'productName': null,
        'excess': 250,
        'excessCode': '3939',
        'levelOfCover': 80,
        'levelOfCoverCode': '3939',
        'annualBenefitLimitCode': '18708',
        'annualBenefitLimit': 20000,
        'planNumber': 972,
        'combinationGroupID': 33000003,
        'basePremium': 204.59,
        'stampDuty': 20.25,
        'gst': 20.46,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -20.46,
          'loadingStampDuty': -2.03,
          'loadingGst': -2.05,
          'loadingNo': 20058,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.04,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 20.4,
        'totalBasePremium': 20.44,
        'totalLoading': -0.04,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR33',
        'productName': null,
        'excess': 0,
        'excessCode': '3944',
        'levelOfCover': 80,
        'levelOfCoverCode': '3944',
        'annualBenefitLimitCode': '18725',
        'annualBenefitLimit': 20000,
        'planNumber': 974,
        'combinationGroupID': 34000001,
        'basePremium': 422.98,
        'stampDuty': 41.88,
        'gst': 42.3,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -42.3,
          'loadingStampDuty': -4.19,
          'loadingGst': -4.23,
          'loadingNo': 20096,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -4.23,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 40.04,
        'totalBasePremium': 42.26,
        'totalLoading': -2.23,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR33',
        'productName': null,
        'excess': 500,
        'excessCode': '3946',
        'levelOfCover': 80,
        'levelOfCoverCode': '3946',
        'annualBenefitLimitCode': '18725',
        'annualBenefitLimit': 20000,
        'planNumber': 974,
        'combinationGroupID': 34000002,
        'basePremium': 241.99,
        'stampDuty': 23.96,
        'gst': 24.2,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -24.2,
          'loadingStampDuty': -2.4,
          'loadingGst': -2.42,
          'loadingNo': 20096,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.42,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 23.76,
        'totalBasePremium': 24.18,
        'totalLoading': -0.42,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }, {
        'productCode': 'PR33',
        'productName': null,
        'excess': 250,
        'excessCode': '3945',
        'levelOfCover': 80,
        'levelOfCoverCode': '3945',
        'annualBenefitLimitCode': '18725',
        'annualBenefitLimit': 20000,
        'planNumber': 974,
        'combinationGroupID': 34000003,
        'basePremium': 270.71,
        'stampDuty': 26.8,
        'gst': 27.07,
        'paymentFrequency': null,
        'paymentFrequencyCode': 'MONTHLY',
        'fixedTerm': 1,
        'isBenefitSchedulePlan': 0,
        'loadings': [{
          'loadingCode': 'DISCOUNT',
          'loadingName': 'Multipet Discount',
          'loadingBase': -27.07,
          'loadingStampDuty': -2.68,
          'loadingGst': -2.71,
          'loadingNo': 20096,
          'webDisplayValue': true,
          'premiumFreeValue': 0
        }, {
          'loadingCode': 'ADMINFEE',
          'loadingName': 'Admin fee $2/instalment',
          'loadingBase': 20.02,
          'loadingStampDuty': 1.98,
          'loadingGst': 2,
          'loadingNo': 20730,
          'webDisplayValue': false,
          'premiumFreeValue': 0
        }],
        'partnerNumber': 'PINSCOM',
        'totalCollectionFee': 2,
        'totalLessDiscount': -2.7,
        'totalOtherBaseLoading': 0,
        'totalPremiumAmount': 26.34,
        'totalBasePremium': 27.05,
        'totalLoading': -0.7,
        'endDate': '0001-01-01T00:00:00',
        'coverPeriod': null
      }],
      'selectedQuote': null,
      'petProducts': [{
        'productCode': 'PR07',
        'productName': 'Illness + Routine',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR08',
        'productName': 'Illness',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR23',
        'productName': 'Accident and Illness and Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR24',
        'productName': 'Accident and Illness and Routine and Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR25',
        'productName': 'Accident & Illness & Dental & Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR26',
        'productName': 'Accident & Illness & Routine & Dental & Hip',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR31',
        'productName': 'Indoor Cat + Dental',
        'partnerNumber': 'PINSCOM'
      }, {
        'productCode': 'PR33',
        'productName': 'Illness and Routine and Dental',
        'partnerNumber': 'PINSCOM'
      }],
      'targetMargetKnockoutSelection': null,
      'productDisclosureCoverage': null,
      'productDisclosureNonCoverage': null
    })],
    'westpac': null,
    'totalPremium': 0,
    'lessFreeMonthAmount': 0,
    'totalAnnualAmount': 0,
    'totalAnnualFreeMonthAmount': 0,
    'paymentStartDate': '2023-08-04T00:00:00Z',
    'policyStartDateId': 0,
    'policyStartDate': '2023-08-03T00:00:00Z',
    'isReferToUnderwriter': null,
    'isAcceptTandC': null,
    'applicationSubmitted': null,
    'isNew': true,
    'currentPetNumber': 0,
    'paymentFrequency': 'Monthly',
    'paymentFrequencyCode': 'MONTHLY',
    'promotionCode': 'FAKE123',
    'hasPromotionCode': true,
    'promotionNo': 0,
    'hasValidPromotion': true,
    'promotionMessage': null,
    'memberNumber': 'P12345678',
    'staffMemberNumber': null,
    'crnNumber': null,
    'hasValidMemberNumber': null,
    'isValidCardHolder': null,
    'promotionEffectiveFrom': null,
    'promotionEffectiveTo': null,
    'hasMemberNumber': false,
    'hasStaffMemberNumber': null,
    'selectedMediaListCode': null,
    'selectedMediaListName': null,
    'hasMediaList': null,
    'isEFulfillment': null,
    'hasRegularVet': null,
    'regularVet': null,
    'regularVetCode': null,
    'staffId': null,
    'hasPensionerNumber': null,
    'pensionerNumber': null,
    'paymentMethodCode': null,
    'officeCode': null,
    'brokerNumber': null,
    'reimbursementInfo': null,
    'stage': null,
    'siteType': null,
    'channel': null,
    'telephone': false,
    'faceToFace': false,
    'web': true,
    'externalId': null,
    'productCodes': null,
    'excesses': null,
    'levelOfCovers': null,
    'annualBenefitLimits': null,
    'fixedTerms': null,
    'paymentFrequencies': null,
    'partners': [{
      'partnerName': 'PINSCOM',
      'broker': 'PICA'
    }],
    'selectedPartner': {
      'partnerName': 'PINSCOM',
      'broker': 'PICA'
    },
    'partnerSequence': null,
    'partnerKey': null,
    'hasZeroPremium': false,
    'hubspotUserToken': '3244d31d43fa3c754e2ad72ca58bda45',
    'pageUri': 'https://ps-preprod-pinscom-qt.petsure.com.au/step1',
    'lcoConsentToProcess': null,
    'lcoConsentText': null,
    'lcoCommSubTypeId': null,
    'lcoCommText': null,
    'retrieveQuoteUrl': null,
    'retrieveCode': null
  }
};